import Vue from 'vue';

// The rail and analytics use this same vocabulary. A dialog is not a query.
export const LEGACY_QUERY_TOOLS = Object.freeze({
  finder: 'filters', ticker: 'ticker-search', platinum: 'platinum', favorites: 'favorites',
  'saved-search': 'saved-searches', description: 'description-search', portfolio: 'portfolio'
});
const SEARCH_ROUTES = ['last-ipos', 'best-bullish-values', 'best-sectors', 'hot-values', 'compatibility', 'exchange', 'sector', 'twin-souls', 'informe'];
export function legacyRouteQuery(route = {}) {
  const type = (route.params || {}).param1;
  if (!type) return { source: 'finder', tool: 'filters' };
  if (['waitings', 'open-positions', 'all-values'].includes(type)) return { source: type, tool: 'portfolio' };
  if (SEARCH_ROUTES.includes(type)) return { source: type, tool: 'saved-searches' };
  if (['platinum', 'favorites', 'ticker'].includes(type)) return { source: type, tool: LEGACY_QUERY_TOOLS[type] };
  // GetStocks interprets an unknown single segment as a direct ticker.
  return { source: 'ticker', tool: 'ticker-search' };
}
export function legacyQueryScope(vm) {
  return JSON.stringify([vm.$store.state.user_id || 0, vm.$route.fullPath || vm.$route.params]);
}
export function createLegacyQuerySelection(scope, route) {
  let reload = null;
  const state = Vue.observable({ override: null, scope: '', revision: 0 });
  return {
    registerReload(handler) { reload = handler; return () => { if (reload === handler) reload = null; }; },
    reload() { return reload ? reload() : Promise.resolve(); },
    current() { return state.scope === scope() && state.override ? state.override : legacyRouteQuery(route()); },
    reset() { state.override = null; state.scope = ''; state.revision++; },
    capture() { return { scope: scope(), revision: state.revision }; },
    isCurrent(token) { return token.scope === scope() && token.revision === state.revision; },
    select(source) {
      if (!LEGACY_QUERY_TOOLS[source]) throw new Error('Unknown classic query source');
      state.scope = scope(); state.override = { source, tool: LEGACY_QUERY_TOOLS[source] }; state.revision++;
    }
  };
}
export const legacyQueryOwner = {
  beforeCreate() {
    this._legacyQuery = createLegacyQuerySelection(() => legacyQueryScope(this), () => this.$route);
  },
  provide() { return { legacyQuery: this._legacyQuery }; },
  created() {
    this.$watch(() => legacyQueryScope(this), () => this._legacyQuery.reset(), { immediate: true });
  }
};
export const legacyQueryConsumer = {
  inject: { legacyQuery: { default: null } },
  computed: {
    activeQuery() { const query = this._legacyQuery || this.legacyQuery; return query ? query.current() : legacyRouteQuery(this.$route); },
    hasQueryTitle() { return this.activeQuery.source !== 'finder'; },
    queryTitle() {
      if (this.activeQuery.source === 'description') return 'Búsqueda por descripción';
      if (this.activeQuery.source === 'saved-search') return 'Búsqueda guardada';
      return this.search_text || this.activeQuery.source;
    }
  }
};
